import { useState } from "react";
import { useSelector } from "react-redux";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import getMenus from "components/Header/data";
import Logo from "assets/images/logo.png";
import {
  StyledAppsIcon,
  StyledLogo,
  DrawerLogo,
  StyledLink,
  UserInfo,
} from "styles/components/header";
import { Collapse } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

const CustomDrawer = () => {
  const user = useSelector((state) => state?.user);
  const [open, setOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState({});
  const MENUS = getMenus(user?.role);

  const toggleDrawer = (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setOpen(!open);
  };

  const handleSubmenuClick = (event, title) => {
    event.stopPropagation();
    setOpenSubmenu((prev) => ({
      ...prev,
      [title]: !prev[title],
    }));
  };

  const renderSubmenuItem = (submenu) => {
    if (submenu.submenus) {
      return (
        <>
          <ListItemButton
            onClick={(e) => handleSubmenuClick(e, submenu.title)}
            sx={{ pl: 4 }}
          >
            {submenu.Icon && (
              <ListItemIcon sx={{ minWidth: "30px" }}>
                <submenu.Icon />
              </ListItemIcon>
            )}
            <ListItemText primary={submenu.title} />
            {openSubmenu[submenu.title] ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse
            in={openSubmenu[submenu.title]}
            timeout="auto"
            unmountOnExit
          >
            <List component="div" disablePadding>
              {submenu.submenus.map((nestedSubmenu) => (
                <ListItem key={nestedSubmenu.title} disablePadding>
                  <StyledLink to={nestedSubmenu.link || "#"}>
                    <ListItemButton sx={{ pl: 8 }}>
                      {nestedSubmenu.Icon && (
                        <ListItemIcon sx={{ minWidth: "30px" }}>
                          <nestedSubmenu.Icon />
                        </ListItemIcon>
                      )}
                      <ListItemText primary={nestedSubmenu.title} />
                    </ListItemButton>
                  </StyledLink>
                </ListItem>
              ))}
            </List>
          </Collapse>
        </>
      );
    }

    if (submenu?.target === "_blank") {
      return (
        <a
          style={{
            color: "inherit",
            textDecoration: "none",
            width: "100%",
          }}
          href={submenu.link}
          target="_blank"
          rel="noreferrer"
        >
          <ListItemButton sx={{ pl: 4 }}>
            {submenu.Icon && (
              <ListItemIcon sx={{ minWidth: "30px" }}>
                <submenu.Icon />
              </ListItemIcon>
            )}
            <ListItemText primary={submenu.title} />
          </ListItemButton>
        </a>
      );
    }

    return null;
  };

  const list = () => (
    <Box
      sx={{
        width: 300,
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
      onClick={toggleDrawer}
      onKeyDown={toggleDrawer}
    >
      <List
        sx={{
          flex: 1,
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#888",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "#555",
          },
        }}
      >
        <DrawerLogo divider>
          <StyledLogo alt="logo" src={Logo} />
        </DrawerLogo>

        {MENUS?.map(({ title, Icon, link, submenus }) => (
          <div key={title + Math.random()}>
            {submenus ? (
              <ListItem disablePadding divider={!openSubmenu[title]}>
                <ListItemButton onClick={(e) => handleSubmenuClick(e, title)}>
                  <ListItemIcon>
                    <Icon />
                  </ListItemIcon>
                  <ListItemText primary={title} />
                  {openSubmenu[title] ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>
            ) : (
              <ListItem disablePadding divider>
                <StyledLink to={link}>
                  <ListItemButton>
                    <ListItemIcon>
                      <Icon />
                    </ListItemIcon>
                    <ListItemText primary={title} />
                  </ListItemButton>
                </StyledLink>
              </ListItem>
            )}

            {submenus && (
              <Collapse in={openSubmenu[title]} timeout="auto" unmountOnExit>
                <List disablePadding onClick={(e) => e.stopPropagation()}>
                  {submenus.map((submenu) => (
                    <ListItem
                      key={submenu.title}
                      disablePadding
                      sx={{ display: "block" }}
                    >
                      {renderSubmenuItem(submenu)}
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            )}
          </div>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <IconButton
        size="large"
        edge="start"
        color="inherit"
        onClick={toggleDrawer}
      >
        <StyledAppsIcon />
      </IconButton>
      <Drawer
        open={open}
        onClose={toggleDrawer}
        PaperProps={{
          sx: {
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        {list()}
        <UserInfo>
          <Typography className="name">{user?.fullName}</Typography>
          <Typography className="role-name">({user?.roleName})</Typography>
        </UserInfo>
      </Drawer>
    </>
  );
};

export default CustomDrawer;
